// extracted by mini-css-extract-plugin
export default {"jsonBlock":"IntegrationDetail_jsonBlock__FtPGl"};